import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Button, Input } from 'antd'
import type { InputProps } from 'antd'
import MaterialCodeModal2 from '@/modules/MaterialCodeModal2'

export interface ProductCodePickerProps {
  // 当前值（与antd Form联动）
  value?: string
  // 值变更（与antd Form联动）
  onChange?: (value: string) => void
  // 输入框属性透传
  inputProps?: InputProps
  // 触发打开弹窗的文字
  linkText?: string
  // 选择后的回调，返回整行记录，便于外层填充其他表单字段
  onSelected?: (record: any) => void
  // 是否禁用
  disabled?: boolean
  // 占位提示
  placeholder?: string
  shipperCode?: string
  onlyPick?: boolean
}

// 一个带“选择”按钮的输入框，点击“选择”打开物料选择弹窗
const ProductCodePicker = forwardRef<HTMLInputElement, ProductCodePickerProps>(
  (props, ref) => {
    const {
      value,
      onChange,
      inputProps,
      linkText = '选择',
      onSelected,
      disabled,
      placeholder = '请输入',
      shipperCode,
      onlyPick,
    } = props

    const [open, setOpen] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null)

    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement)

    const handlePick = (record: any) => {
      // 默认将物料编码写入输入框
      const code = record?.code ?? ''
      onChange?.(code)
      onSelected?.(record)
      setOpen(false)
    }

    return (
      <div>
        <Input
          ref={inputRef as any}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={disabled}
          placeholder={placeholder}
          {...inputProps}
          readOnly={onlyPick}
          suffix={
            <Button
              type="link"
              onClick={() => !disabled && setOpen(true)}
              disabled={disabled}
            >
              {linkText}
            </Button>
          }
        />
        {/* <a
          className={`picker-link ${disabled ? 'picker-link-disabled' : ''}`}
          onClick={() => !disabled && setOpen(true)}
        >
          {linkText}
        </a> */}
        <MaterialCodeModal2
          open={open}
          shipperCode={shipperCode}
          onCancel={() => setOpen(false)}
          onRowSelect={handlePick}
        />
      </div>
    )
  },
)
ProductCodePicker.displayName = 'ProductCodePicker'
export default ProductCodePicker
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Button, Input } from 'antd'
import type { InputProps } from 'antd'
import MaterialCodeModal2 from '@/modules/MaterialCodeModal2'

export interface ProductCodePickerProps {
  // 当前值（与antd Form联动）
  value?: string
  // 值变更（与antd Form联动）
  onChange?: (value: string) => void
  // 输入框属性透传
  inputProps?: InputProps
  // 触发打开弹窗的文字
  linkText?: string
  // 选择后的回调，返回整行记录，便于外层填充其他表单字段
  onSelected?: (record: any) => void
  // 是否禁用
  disabled?: boolean
  // 占位提示
  placeholder?: string
  shipperCode?: string
  onlyPick?: boolean
}

// 一个带“选择”按钮的输入框，点击“选择”打开物料选择弹窗
const ProductCodePicker = forwardRef<HTMLInputElement, ProductCodePickerProps>(
  (props, ref) => {
    const {
      value,
      onChange,
      inputProps,
      linkText = '选择',
      onSelected,
      disabled,
      placeholder = '请输入',
      shipperCode,
      onlyPick,
    } = props

    const [open, setOpen] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null)

    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement)

    const handlePick = (record: any) => {
      // 默认将物料编码写入输入框
      const code = record?.code ?? ''
      onChange?.(code)
      onSelected?.(record)
      setOpen(false)
    }

    return (
      <div>
        <Input
          ref={inputRef as any}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={disabled}
          placeholder={placeholder}
          {...inputProps}
          readOnly={onlyPick}
          suffix={
            <Button
              type="link"
              onClick={() => !disabled && setOpen(true)}
              disabled={disabled}
            >
              {linkText}
            </Button>
          }
        />
        {/* <a
          className={`picker-link ${disabled ? 'picker-link-disabled' : ''}`}
          onClick={() => !disabled && setOpen(true)}
        >
          {linkText}
        </a> */}
        <MaterialCodeModal2
          open={open}
          shipperCode={shipperCode}
          onCancel={() => setOpen(false)}
          onRowSelect={handlePick}
        />
      </div>
    )
  },
)
ProductCodePicker.displayName = 'ProductCodePicker'
export default ProductCodePicker
